<fgb-banner [title]="('home.page.title' | translate) + ', ' + (name$ | async)"> </fgb-banner>

<fgb-barcode [isHomePage]="true" (onShowQr)="onShowQr($event)" [showQr]="true"></fgb-barcode>

<div #homeContainer class="home-container">
  <ng-container *ifScreenSize="screenType.Mobile">
    <ng-container *notInPopulation="[populations.Suite, populations.Pts]">
      <div class="grab-point"><span class="minimize-icon"> </span></div>
    </ng-container>
  </ng-container>

  <ng-container *ifScreenSize="screenType.Desktop">
    <ng-container *inPopulation="[populations.Suite]">
      <div class="container mb-30">
        <div class="ballpark-container d-flex flex-column align-item-center justify-content-center">
          <img src="assets/images/ballpark-banner.png" alt="" class="ballpark-banner w-100" />

          <div class="ballpark-content d-flex flex-column align-items-center justify-content-center">
            <div class="font-heading font-size-25 text-uppercase text-white">{{ 'home.ballpark.title' | translate }}</div>
            <div class="text-white font-size-14">{{ 'home.ballpark.description' | translate }}</div>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <ng-container *inPopulation="[populations.Free, populations.Partner, populations.Default]">
    <div class="container mb-30">
      <div class="voucher-container">
        <fgb-vouchers></fgb-vouchers>
      </div>
      <div class="rewards-container">
        <fgbcl-featured-rewards [showAllPath]="'rewards'"></fgbcl-featured-rewards>
      </div>
    </div>
  </ng-container>

  <!-- Announcement -->
  <div class="container mb-30">
    <fgbcl-announcements></fgbcl-announcements>
  </div>

  <ng-container *inPopulation="[populations.Free, populations.Partner, populations.Default]">
    <fgbcl-campaigns-offers-list
      (dataChange)="onCampaignOfferListChange($event)"
      [showAllOffers]="true"
    ></fgbcl-campaigns-offers-list>

    <ng-contaier *ifScreenSize="screenType.Mobile">
      <!--Scorecard carousel-->
      <div class="container challenges-container">
        <fgbcl-scorecard-carousel [link]="'badges'" [icon]="'chevron_right'" [showAllView]="true"></fgbcl-scorecard-carousel>
      </div>
    </ng-contaier>
  </ng-container>
</div>
